export default "__VITE_ASSET__BwdHM8B$__"